import {
  Legend,
  Line,
  LineChart,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import CustomTooltip from "../CustomToolTip";

const OverviewChart = ({ data }) => {
  const today = new Date().toISOString().split("T")[0];

  return (
    <div>
      <h5 className="mb-4">Balance Cumsum</h5>
      <ResponsiveContainer width="100%" height={350}>
        <LineChart data={data}>
          <XAxis dataKey="due_date" />
          <YAxis tickFormatter={(value) => value.toLocaleString()} />

          <Line
            dot={false}
            strokeWidth={6}
            type="monotone"
            dataKey="payment_balance_cumsum"
            stroke="oklch(66.7% 0.295 322.15)"
            name="Payment Balance"
          />
          <Line
            dot={false}
            strokeWidth={3}
            type="monotone"
            dataKey="payment_invoice_recurring_balance_cumsum"
            stroke="oklch(68.5% 0.169 237.323)"
            name="Balance + AR/AP + Recur"
          />
          <Line
            dot={false}
            type="monotone"
            strokeWidth={1}
            dataKey="forecast_balance_cumsum"
            stroke="oklch(70.4% 0.14 182.503)"
            name="Final Forecast"
          />
          <ReferenceLine y={0} stroke="green" strokeDasharray="3 3" />
          <ReferenceLine x={today} stroke="red" strokeDasharray="3 3" />
          <Tooltip content={CustomTooltip} />
          <Legend
            wrapperStyle={{
              marginTop: 10,
            }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default OverviewChart;
